import styled from "styled-components"
import styleWithOrgDesign from "QuorumGrassroots/styled-components/connect"

export const LandingPageContainer = styleWithOrgDesign(styled.div`
    width: 100%;
    max-width: 50rem;
    margin: 2rem auto;
    padding: 2rem;
    background-color: #f8f9fa;
    border-radius: 16px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);

    @media (max-width: 768px) {
        margin: 1.5rem auto;
        padding: 1.5rem;
        border-radius: 12px;
    }
`)

export const ActionButtonsGrid = styleWithOrgDesign(styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    width: 100%;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 0.75rem;
    }
`)

export const ActionButton = styleWithOrgDesign(styled.button`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem 1.5rem;
    border: 2px solid #e9ecef;
    border-radius: 12px;
    background-color: white;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    min-height: 120px;

    &:hover {
        border-color: #007bff;
        box-shadow: 0px 4px 16px -4px rgba(0, 123, 255, 0.2);
        transform: translateY(-2px);
    }

    &:focus {
        outline: 2px solid #007bff;
        outline-offset: 2px;
    }

    &:active {
        transform: translateY(0);
    }

    /* Specific button styling based on design specs */
    &.voter-btn:hover {
        border-color: #28a745;
        box-shadow: 0px 4px 16px -4px rgba(40, 167, 69, 0.2);
    }

    &.candidates-btn:hover {
        border-color: #17a2b8;
        box-shadow: 0px 4px 16px -4px rgba(23, 162, 184, 0.2);
    }

    &.officials-btn:hover {
        border-color: #ffc107;
        box-shadow: 0px 4px 16px -4px rgba(255, 193, 7, 0.2);
    }

    &.calendar-btn:hover {
        border-color: #dc3545;
        box-shadow: 0px 4px 16px -4px rgba(220, 53, 69, 0.2);
    }

    @media (max-width: 768px) {
        padding: 1.5rem 1rem;
        min-height: 100px;
    }
`)

export const ButtonIcon = styleWithOrgDesign(styled.div`
    font-size: 2rem;
    margin-bottom: 0.5rem;

    @media (max-width: 768px) {
        font-size: 1.75rem;
        margin-bottom: 0.25rem;
    }
`)

export const ButtonText = styleWithOrgDesign(styled.span`
    font-size: 1rem;
    font-weight: 600;
    color: #333;
    text-align: center;
    line-height: 1.2;

    @media (max-width: 768px) {
        font-size: 0.9rem;
    }
`)
